<template>
    <div tabIndex="0" @focusout="onBlur" class="sc-emoji-picker" ref="domNode">
        <div class="input-wrapper form-input-text input-has-full-border">
            <input v-model="searchValue" type="text" placeholder="Search only in English (e.g. face)" class="full-border" />
        </div>

        <div class="sc-emoji-picker--content">
            <div v-for="(item, name, index) in emojisArray" class="sc-emoji-picker--category" :key="index">
                <div class="sc-emoji-picker--category-title">{{ __(name) }}</div>
                <template
                     v-for="emoji in item"
                >
                <span
                    :key="emoji.emoji"
                    :class="['sc-emoji-picker--emoji', {'emoji-2x': emoji.wider}]"
                    :title="emoji.description"
                    @click="emojiClicked(emoji.emoji)"
                >
                    {{ emoji.emoji }}
                </span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import EmojiConvertor from 'emoji-js'
    import emojiData from './emojiData'

    export default {
        props: {
            onBlur: {
                type: Function,
                required: true
            },
            onEmojiPicked: {
                type: Function,
                required: true
            }
        },
        data() {
            return {
                emojiData,
                emojiConvertor: new EmojiConvertor(),
                searchValue: ''
            }
        },
        watch: {
            emojis(value) {
                console.log(value)
            }
        },
        mounted() {
            const elem = this.$refs.domNode
            elem.style.opacity = 0
            window.requestAnimationFrame(() => {
                elem.style.transition = 'opacity 350ms'
                elem.style.opacity = 1
            })
            this.$refs.domNode.focus()
            this.emojiConvertor.init_env()
        },
        computed: {
            emojisArray() {
                let emojis = JSON.parse(JSON.stringify(this.emojiData))

                emojis[0].emojis = emojis[0].emojis.filter((item) => {
                    if(item.unicode_version !== "14.0" && item.ios_version !== "13.2" && item.ios_version !== "14.0" && item.ios_version !== "15.4") {
                        return item
                    }
                })

                if (this.searchValue != '' && this.searchValue) {
                    emojis[0].emojis = emojis[0].emojis.filter((item) => {
                        if(item.description.toLowerCase().includes(this.searchValue.toLowerCase())) {
                            return item
                        }
                    })
                }

                emojis[0].emojis = _.groupBy(emojis[0].emojis, 'category')

                return emojis[0].emojis
            }
        },
        methods: {
            emojiClicked(emoji) {
                this.onEmojiPicked(emoji)
                this.$refs.domNode.blur()
            },
        },
    }
</script>
